import { AxiosResponse } from "axios";
import { Axios } from "../Axios";
import { TypeEmailTipo } from "../../Models/Pessoa/Contato/Email";

export class EmailService {
    public listarTiposEmails(): Promise<AxiosResponse<TypeEmailTipo[]>>{
        return Axios.get<TypeEmailTipo[]>(`Email/listarTiposEmails`);
    }

}